import { GetReportFormat } from '../apiTypes';
import {
  createHeaderWithCredentials,
  fetchWithAuth,
  getApiUrl,
  getHeader,
} from '../apiUtils';

interface TemplateFormatParams {
  templateId: number;
}

const endPoint = 'inspection/report/format';

export const getReportFormat = async (
  params: TemplateFormatParams,
): Promise<GetReportFormat> => {
  const queryParams = new URLSearchParams();
  queryParams.append('templateId', params.templateId.toString());
  const apiUrl = getApiUrl(endPoint);
  const url = `${apiUrl}?${queryParams.toString()}`;
  const header = getHeader({
    method: 'GET',
  });

  const response = await fetchWithAuth(
    url,
    createHeaderWithCredentials(header),
  );
  return response.data;
};
